import { Pipe, PipeTransform } from '@angular/core';
import { AutocompleteFilter, Filter } from '@models/filter-types';
import { isAutocompleteFilter } from '@shared/helpers/functions/helpers';

@Pipe({
    name: 'isAutocompleteFilter',
    standalone: false,
})
export class IsAutocompleteFilterPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: Filter<any>): value is AutocompleteFilter<unknown> {
        return isAutocompleteFilter(value);
    }
}
